import React, { useState } from "react";
import style from "./Styles.module.css";
import ImageLoader from "../ImageLoader";

function Collapsible({ title, subTitle, description, className = "", defaultOpen = false }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const rootClass = [style.collapsibleView, className].join(" ").trim();

  // Render description depending on type
  const renderDescription = () => {
    if (!description) return null;

    // Case: array of objects
    if (Array.isArray(description)) {
      return description.map((item, index) => (
        <div key={index} className={style.row}>
          <p className={style.key}>{item.key}: </p>
          <p>{item.value}</p>
        </div>
      ));
    }

    // Case: single object
    if (typeof description === "object") {
      return (
        <div className={style.row}>
          <p className={style.key}>{description.key}:</p>
          <p>{description.value}</p>
        </div>
      );
    }

    // Case: string (HTML or plain text)
    if (typeof description === "string") {
      return (
        <div
          dangerouslySetInnerHTML={{ __html: description }}
        />
      );
    }

    return null;
  };

  return (
    <div className={rootClass}>
      <div onClick={() => setIsOpen(!isOpen)} className={style.header}>
        <div className={style.headerContents}>
          <p className={style.title}>{title}</p>
          {subTitle ? <p className={style.subTitle}>{subTitle}</p> : null}
        </div>

        <ImageLoader
          className={`${style.toggleView} ${style.transition} ${isOpen ? style.rotate180 : style.rotate0
            }`}
          src={
            isOpen
              ? require("../../media/icons/icon_minus.png")
              : require("../../media/icons/icon_plus.png")
          }
          alt="toggle icon"
        />
      </div>

      {/* Description */}
      <div
        className={`${style.transition} ${isOpen ? style.open : style.closed
          }`}
      >
        <div className={style.contents}>{renderDescription()}</div>
      </div>
    </div>
  );
}

export default Collapsible;